import { render, staticRenderFns } from "./UserFaq.vue?vue&type=template&id=455339c4&"
import script from "./UserFaq.vue?vue&type=script&lang=js&"
export * from "./UserFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports